import AgentAssignments from "@/views/console/AgentAssignments";
import C from "@/utils/constants";

export default [
  {
    path: "agent-assignments",
    component: AgentAssignments,
    meta: {
      roles: [
        C.ROLE.ADMIN,
        C.ROLE.MANAGER,
        C.ROLE.QA_TEAM,
        C.ROLE.CSR_SUPERVISOR,
      ],
    },
    children: [
      {
        path: "",
        name: "agent-assignments",
        component: () =>
          import(
            "../components/console/agent-assignments/AgentAssignmentsList"
          ),
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.CSR_SUPERVISOR,
            C.ROLE.AGENT_ENGAGEMENT,
          ],
        },
      },
    ],
  },
];
